import { type Market } from "@dotcom/markets";
import { isFullUrl } from "@dotcom/url";

import isNaMarket from "../isNaMarket/isNaMarket";

const getRelativeUrl = (url: string) => {
  if (isFullUrl(url)) {
    const parsedUrl = new URL(url);
    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  }

  return url;
};

/**
 * Handles NA markets legal requirements by replacing `partnerships` with `collaborations`
 * in the URL path if the market region is North America.
 */
const getPartnershipsUrl = (
  /**
   * The URL to check. Either absolute or relative.
   */
  url: string,
  /**
   * The market to check the URL against.
   */
  market: Market,
  config: {
    /**
     * If true, the function will return a relative URL.
     */
    relative?: boolean;
  } = {}
) => {
  const { relative = false } = config;
  const relativeUrl = getRelativeUrl(url);
  const newUrl = new URL(relativeUrl, "https://www.polestar.com");

  // /us/partnerships -> /us/collaborations
  if (isNaMarket(market) && url.includes("partnerships")) {
    newUrl.pathname = newUrl.pathname.replace(
      "/partnerships",
      "/collaborations"
    );

    if (isFullUrl(url) && !relative) {
      return newUrl.href;
    }

    return getRelativeUrl(newUrl.href);
  }

  // /uk/collaborations -> /uk/partnerships
  if (!isNaMarket(market) && url.includes("collaborations")) {
    if (isFullUrl(url) && !relative) {
      return url.replace("collaborations", "partnerships");
    }

    return getRelativeUrl(url).replace("collaborations", "partnerships");
  }

  return url;
};

export default getPartnershipsUrl;
